import type { TsAffiliatesResponse } from "./types";

const IMPACT_AGGREGATOR = "IMPACT";

/**
 * `feAffiliateId` for travel-services clicks tied to the flights IMPACT channel:
 * `id` from get-affiliates where `aggregatorName` is IMPACT (aggregators list or flight websites).
 */
export function feAffiliateIdFromGetAffiliatesResponse(
  res: TsAffiliatesResponse
): number {
  for (const row of res.aggregators ?? []) {
    if (row.aggregatorName?.toUpperCase() === IMPACT_AGGREGATOR) {
      const n = parseInt(String(row.id), 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
  }
  for (const aff of res.affiliates ?? []) {
    for (const w of aff.websites ?? []) {
      if (w.aggregatorName?.toUpperCase() === IMPACT_AGGREGATOR) {
        const n = parseInt(String(w.id), 10);
        if (Number.isFinite(n) && n > 0) return n;
      }
    }
  }
  return 0;
}

/**
 * `feAffiliateName` for travel-services clicks tied to the flights IMPACT channel:
 * website `name` where `aggregatorName` is IMPACT; falls back to the aggregatorName itself.
 */
export function feAffiliateNameFromGetAffiliatesResponse(
  res: TsAffiliatesResponse
): string {
  for (const aff of res.affiliates ?? []) {
    for (const w of aff.websites ?? []) {
      if (w.aggregatorName?.toUpperCase() === IMPACT_AGGREGATOR) {
        const n = parseInt(String(w.id), 10);
        if (Number.isFinite(n) && n > 0) return w.name ?? "";
      }
    }
  }
  for (const row of res.aggregators ?? []) {
    if (row.aggregatorName?.toUpperCase() === IMPACT_AGGREGATOR) {
      const n = parseInt(String(row.id), 10);
      if (Number.isFinite(n) && n > 0) return row.aggregatorName ?? "";
    }
  }
  return "";
}
